import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MainNavigation from "../components/navigation/MainNavigation";
import LandingNavbar from "../components/landing/LandingNavbar";
import LandingFooter from "../components/landing/LandingFooter";
import "../components/landing/landing.css";
import "../components/landing/landing-sections.css";
import { isAdminPanelRoute } from "../admin/navigation/adminNavigation";
import AdminLayoutShell from "../admin/navigation/AdminLayoutShell";
import "../admin/navigation/AdminShell.css";
import Notification from "../components/common/notification/Notification";
import "./Root.css";

const FULLSCREEN_AUTH_ROUTES = new Set([
  "/login",
  "/sign-up",
  "/sign-up/complete-profile",
  "/Email-Screen",
  "/OTP-Screen",
  "/reset-password",
  "/partner/signup",
  "/partner/verify-otp",
  "/partner/onboarding",
  "/partner/profile",
  "/partner/services",
  "/partner/documents",
  "/partner/subscription",
  "/partner/verification",
]);

// Public marketing pages share the landing navbar and footer
const PUBLIC_MARKETING_PREFIXES = [
  "/about-us",
  "/contactus",
  "/property-services",
  "/interiordesign",
  "/blogs",
  "/privacy-policy",
  "/terms-and-conditions",
  "/refund-policy",
  "/policy",
  "/help",
];

const CUSTOMER_ROUTE_PREFIXES = [
  "/customer",
  "/partner",
  "/dashboard",
  "/user/profile",
  "/user/edit-profile",
  "/user/upload-documents",
  "/user/payment-details",
  "/user/upload-payment-screen-shot",
  "/my-preference",
  "/changepassword",
];

function RootLayout() {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState.user;
  const location = useLocation();
  const adminPanelRoute = isAdminPanelRoute(location.pathname, authState);
  const adminLoginRoute = location.pathname === "/admin-login";
  const isFullscreenAuthRoute = FULLSCREEN_AUTH_ROUTES.has(location.pathname);
  const isCustomerDashboardRoute = CUSTOMER_ROUTE_PREFIXES.some((prefix) =>
    location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
  );
  // The landing page ("/") renders its own navbar and footer.
  const isLandingRoute = location.pathname === "/";
  const isPublicMarketingRoute = PUBLIC_MARKETING_PREFIXES.some(
    (prefix) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
  );
  const shouldShowSiteNavbar =
    !adminLoginRoute && !isFullscreenAuthRoute && !isCustomerDashboardRoute && !isLandingRoute && !isPublicMarketingRoute;
  const isUserLoggedIn = Boolean(
    loggedInUser &&
      (loggedInUser.refreshToken ||
        loggedInUser.token ||
        loggedInUser.accessToken ||
        loggedInUser.user ||
        loggedInUser.id)
  );
  const isNoFooterRoute =
    location.pathname === "/post/add-post" ||
    location.pathname.startsWith("/post") ||
    location.pathname.startsWith("/customer/posts");
  const shouldShowSiteFooter =
    !isUserLoggedIn &&
    !adminLoginRoute &&
    !isFullscreenAuthRoute &&
    !isCustomerDashboardRoute &&
    !isLandingRoute &&
    !isPublicMarketingRoute &&
    !isNoFooterRoute;
  if (adminPanelRoute) {
    return (
      <div className="admin-root-layout">
        <AdminLayoutShell>
          <Outlet />
        </AdminLayoutShell>
        <Notification />
      </div>
    );
  }

  if (isPublicMarketingRoute) {
    return (
      <div className="ahd-landing">
        <LandingNavbar />
        <main id="main-content">
          <Outlet />
        </main>
        <LandingFooter />
        <Notification />
      </div>
    );
  }

  return (
    <div className="rootl">
      {shouldShowSiteNavbar ? <MainNavigation /> : null}
      <main className="rootl__main">
        <Outlet />
      </main>
      {shouldShowSiteFooter ? (
        <div className="ahd-landing">
          <LandingFooter />
        </div>
      ) : null}
      <Notification />
    </div>
  );
}

export default RootLayout;
